import { LoyaltyItemType } from '../loyalty/loyalty.types';
import { IScheduling, Item, ModifierGroup, ModifierOptions } from './menu.types';
import { ModType } from './modifier.types';

export interface itemRequestType {
  itemName: string;
  itemDescription: string;
  itemPrice: number;
  calories: number;
  quantity: number;
  preparationTime: string;
  stockStatus: string;
  sortOrder: number;
  showOnMenu: boolean;
  showOnline: boolean;
  showPOS: boolean;
  showQR: boolean;
  showThirdParty: boolean;
  posDisplayName: string;
  kdsName: string;
  modifergroupId?: number;
  modifierId?: number;
  tagId?: number;
  isDiscount?: boolean | null;
  discountPercentage?: number | null;
  startTime?: string;
  endTime?: string;
  saleCategory?: SaleCategory;
  alcoholExist?: boolean;
  isSettingsVisible?: boolean;
}

export interface VisibilityOptionsType {
  deviceDay?: string;
  deviceTime?: string;
  deviceDate?: string;
  deviceType?: string;
  restaurantId?: number;
  itemIds?: number[];
}

export interface PopularItemRequesType extends VisibilityOptionsType {
  minimumOrders?: number;
  limit?: number;
  onlyCount?: boolean;
  restaurantId: number;
  fromCart?: string;
  userId?: string;
  menuId?: number[];
  itemIds?: number[];
}

export interface PopularItemRequesType {
  minimumOrders?: number;
  limit?: number;
  onlyCount?: boolean;
  restaurantId: number;
  fromCart?: string;
  userId?: string;
}

export interface itemResponseType {
  data: itemDataResponse;
  message: string;
  error?: string | null;
}

export interface popularItemsResponseType {
  data: PopularItemType[];
  message: string;
  error?: string | null;
}

export interface itemDataResponse extends itemRequestType {
  id: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface PopularItemType {
  itemId?: string;
  itemName: string;
  itemPrice: number;
  itemPicture: string;
  onlineImage: string;
  landscapeImage?: string;
  isDiscount: boolean;
  discountPercentage: number;
  stockStatus: string;
  showOnMenu: boolean;
  preparationTime: string;
  ticketCount?: number;
  hasModifier?: boolean;
  actualPrice?: number;
  discountedPrice?: number;
  minLimt?: number;
  maxLimt?: number;
  noMaxLimit?: boolean;
}

export interface ItemModifierGroupsResponse {
  itemId: number;
  optionalModifierGroups: ModifierGroup[] | null;
  requiredModifierGroups: ModifierGroup[] | null;
  addOns: Item[];
  loyaltyItems: LoyaltyItemType[];
}
export interface IVisibility {
  isVisible: boolean;
}

//For Dashboard

export interface IVisibility {
  isVisible: boolean;
  isDefault: boolean;
  channelVisibilityType: string; // need to add enums
  device: string | '';
  scheduling: IScheduling[];
}

export interface IItem {
  id?: number | null;
  itemName: string;
  posDisplayName: string;
  kdsName: string;
  itemDescription?: string;
  itemPicture?: string;
  posImage?: string;
  onlineImage?: string;
  kioskImage?: string;
  thirdPartImage?: string;
  itemPrice?: number;
  totalPrice?: number;
  taxLinkedWithParentSettings?: boolean;
  calculatePriceWithTaxInclude?: boolean;
  takeOutException?: boolean;
  stockStatus?: string;
  stockValue?: number;
  orderQuantityLimit?: boolean;
  minLimit?: number;
  maxLimit?: number;
  noMaxLimit?: boolean;
  calories?: number;
  inheritModifierFromCategory?: boolean;
  preprationTime?: string;
  saleCategory?: SaleCategory;
  alcoholExist?: boolean;
}

export interface IItemList {
  id?: number | null;
  itemName: string;
  itemPicture?: string;
  posDisplayName: string;
  kdsName: string;
  itemDescription?: string;
  category?: string[];
  posImage?: string;
  onlineImage?: string;
  kioskImage?: string;
  thirdPartImage?: string;
  itemPrice?: number;
  totalPrice?: number;
  taxLinkedWithParentSettings?: boolean;
  calculatePriceWithTaxInclude?: boolean;
  takeOutException?: boolean;
  stockStatus?: string;
  stockValue?: number;
  orderQuantityLimit?: boolean;
  minLimit?: number;
  maxLimit?: number;
  noMaxLimit?: boolean;
  calories?: number;
  inheritModifierFromCategory?: boolean;
  preprationTime?: string;
  alcoholExist?: boolean;
}
export interface Tax {
  id?: number;
  name: string;
  percentage: number;
}

export interface Modifier {
  modifierName: string;
  isStockAvailable: boolean;
}

export interface Tags {
  id?: number | null;
  value?: string;
}
export interface ITags {
  id: number;
  label: string;
  sortOrder?: number;
}

export interface Allergens {
  id?: number | null;
}

export interface IModifierAndGroups {
  id?: number;
  label?: string;
  type: string;
  sortOrder?: number;
  isOptional?: boolean;
  customTypeLabel?: string;
  customOptionalLabel?: string;
  modType?: ModType;
}

export interface IItemRequestType {
  id?: number | null;
  itemName: string;
  posDisplayName: string;
  kdsName: string;
  itemDescription?: string;
  posImage?: string;
  onlineImage?: string;
  kioskImage?: string;
  thirdPartImage?: string;
  itemPrice: number;
  totalPrice: number;
  taxLinkedWithParentSettings?: boolean;
  calculatePriceWithTaxInclude?: boolean;
  takeOutException?: boolean;
  stockStatus?: string;
  stockValue?: number;
  orderQuantityLimit?: boolean;
  minLimit?: number;
  maxLimit?: number;
  noMaxLimit?: boolean;
  calories?: number;
  inheritModifierFromCategory?: boolean;
  preprationTime?: string;
  alcoholExist?: boolean;
}

export interface ItemResponseType {
  data: ItemDataResponse;
  message: string;
  error?: string | null;
}

export interface IItemStation {
  id?: number;
  name?: string;
}

export interface ItemTax {
  id?: number;
}

export interface ITags {
  id: number;
  label: string;
  sortOrder?: number;
}

export interface ISizeItem {
  id?: number;
  size?: string;
  price?: number;
  totalPrice?: number;
}

export interface ISizePriceModifierOption {
  id?: number;
  optionName?: string;
  price?: number;
  totalPrice?: number;
}

export interface ItemDataResponse {
  //TODO: Need to update
  item: IItem;
  itemCategories: any;
  itemTaxes: any;
  itemStations?: any;
  itemTags: any;
  itemAllergens: any;
  ModifierAndModifierGroup: any;
  itemAddOns: any;
}

export interface ItemRequestType {
  item: Item;
  tax?: Tax;
  modifiers?: Modifier;
  tags?: Tags[];
  allergens?: Allergens[];
  onPrem?: IVisibility;
  offPrem?: IVisibility;
  custom?: IVisibility[] | [];
}

export interface IItemResponse {
  items: IItemList[];
  totalCount: number;
}

export interface IItemNotInLoyaltyResponse {
  items: (Item & { modifierOption?: ModifierOptions })[];
}

export interface ItemTag {
  tagId: number;
  itemId: number;
}

export interface IItemAllergen {
  allergenId: number;
  itemId: number;
}

export interface ItemAddOn {
  value?: any;
  itemId: number;
  addonId: number;
}

export interface IITemTags {
  itemId: number;
  tagId: number;
}

export interface IItemModifier {
  itemId: number;
  modifierId: number;
  sortOrder: number;
  modifierName?: string;
  customTypeLabel?: string;
  isOptional?: boolean;
  modType?: ModType;
}

export interface IItemModifierGroup {
  itemId: number;
  modifierGroupId: number;
  sortOrder: number;
  groupName?: string;
}

export interface PopularItemsNewResponseType {
  data: MostOrderedItemsType[];
  message: string;
  error?: string | null;
}

export interface MostOrderedItemsType {
  itemId: number;
  menuId: number;
}

export type ItemFilter = Partial<IItem>;

export interface CampaingItems {
  items: IItemList[];
  newArrivals: IItemList[];
  topSellers: IItemList[];
}

export enum ItemTypeEnum {
  TicketItem = 'ticket-item',
  CustomItem = 'custom-item',
}

export enum SaleCategory {
  FOOD_SALES = 'Food Sales',
  BEER_SALES = 'Beer Sales',
  WINE_SALES = 'Wine Sales',
  LIQUOR_SALES = 'Liquor Sales',
  //  value should be Non Alcoholic Beverages Sales
  NON_ALCOHOLIC_BEVERAGE_SALES = 'Non-Alcoholic Beverages Sales',
  NON_FOOD_ITEMS = 'Non-Food Items',
  COCKTAILS = 'Cocktails',
  MOCKTAILS = 'Mocktails',
}
export interface ItemData {
  id: number; // Unique identifier for the item
  itemName: string; // Name of the item
  posDisplayName: string; // Display name for POS
  kdsName: string; // Name for KDS
  itemDescription: string; // Description of the item
  itemPicture: string; // URL for the item's picture
  onlineImage: string; // URL for the online image of the item
  landscapeImage: string; // URL for the landscape image of the item
  thirdPartyImage: string; // URL for third-party platforms image
  kioskItemImage: string; // URL for the kiosk-specific image
  itemPrice: number; // Price of the item
  taxLinkedWithParentSetting: boolean; // Indicates if the tax is linked with the parent setting
  calculatePricesWithTaxIncluded: boolean; // Indicates if prices are calculated with tax included
  takeoutException: boolean; // Indicates if the item is an exception for takeout
  stockStatus: string; // Status of the item's stock
  stockValue: number; // Quantity of the stock
  orderQuantityLimit: number; // Limit on the order quantity
  minLimit: number; // Minimum limit for the item
  maxLimit: number; // Maximum limit for the item
  noMaxLimit: boolean; // Indicates if there is no maximum limit
  stationIds: string; // Comma-separated station IDs
  preparationTime: number; // Preparation time in minutes
  calories: number; // Number of calories in the item
  tagIds: string; // Comma-separated list of tag IDs
  inheritTagsFromCategory: boolean; // Indicates if tags are inherited from the category
  saleCategory: string; // Sale category of the item
  allergenIds: string; // Comma-separated list of allergen IDs
  inheritModifiersFromCategory: boolean; // Indicates if modifiers are inherited from the category
  addonIds: string; // Comma-separated list of addon IDs
  isSpecialRequest: boolean; // Indicates if the item is a special request
  settingId?: number;
  doordashPrice: number; // Price for DoorDash
  uberEatsPrice: number; // Price for Uber Eats
  grubHubPrice: number; // Price for GrubHub
}
export interface ItemStation {
  itemId: number;
  stationsId: number;
}

export interface ITax {
  id: number;
  name: string;
  taxValue: number;
  value: boolean;
  takeOutRate: number;
  isTakeoutTaxEnabled: boolean;
}
